import { useRef } from "react";
import useValidFieldUpdate from "./useValidFieldUpdate.esm.js";
const UninitializedSymbol = Symbol("object is not yet loaded from local storage");
function useLocallyStoredObject(key, defaultValue, options = {
  disablePersistance: false
}) {
  var _a, _b, _c;
  const value = useRef(UninitializedSymbol);
  if (value.current === UninitializedSymbol) {
    value.current = {
      ...defaultValue,
      ...options.disablePersistance ? null : JSON.parse(((_b = (_a = global.window) == null ? void 0 : _a.localStorage) == null ? void 0 : _b.getItem(key)) || "null")
    };
    if (!options.disablePersistance) {
      (_c = global.window) == null ? void 0 : _c.localStorage.setItem(key, JSON.stringify(value.current));
    }
  }
  return value.current;
}
function useStoreValidFieldsLocally(key, form, options = {
  disablePersistance: false
}) {
  const prevValues = useRef(UninitializedSymbol);
  useValidFieldUpdate(form, (name, value) => {
    var _a, _b, _c;
    if (options.disablePersistance) {
      return;
    }
    if (prevValues.current === UninitializedSymbol) {
      prevValues.current = JSON.parse(((_b = (_a = global.window) == null ? void 0 : _a.localStorage) == null ? void 0 : _b.getItem(key)) || "null");
    }
    const nextValues = {
      ...prevValues.current,
      [name]: value
    };
    prevValues.current = nextValues;
    (_c = global.window) == null ? void 0 : _c.localStorage.setItem(key, JSON.stringify(nextValues));
  });
}
export {
  useLocallyStoredObject,
  useStoreValidFieldsLocally
};
